import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import 'dayjs/locale/de';

dayjs.locale('de');
dayjs.extend(isoWeek);

export default dayjs;
